var ChangedScoresModifier = /** @class */ (function () {
    function ChangedScoresModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    ChangedScoresModifier.prototype.modify = function (content) {
        if (content.scores === undefined || content.scores.change === undefined) {
            return;
        }
        var scores = content.scores.change;
        for (var i = 0; i < scores.length; i++) {
            var score = scores[i];
            var scoreKey = this._modelKeyRepository.getScoreKey(score.id);
            scores[i] = Object.assign({
                score1: score.s1,
                score2: score.s2,
                team: score.tm,
                type: score.t,
                isActive: score.ia
            }, scoreKey);
        }
    };
    return ChangedScoresModifier;
}());
export default ChangedScoresModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/ChangedScoresModifier.js